"use client";

import React from "react";
import { MapPin, Phone, Mail, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const siteNav = [{
  label: "Startseite",
  href: "/"
}, {
  label: "Unser Campus",
  href: "https://excited-caiman.10web.cloud/unser-campus/"
}, {
  label: "Über das Zentrum",
  href: "/ueber-das-zentrum"
}, {
  label: "Aktuelle Termine",
  href: "/Aktuelle-Termine"
}, {
  label: "Kontakt und Anfahrt",
  href: "https://excited-caiman.10web.cloud/kontakt-und-anfahrt/"
}];
const branches = [{
  label: "Psychologische Praxis Soonwald",
  href: "https://praxis-soonwald.de",
  color: "#673DBD"
}, {
  label: "Organisationsberatung & Coaching",
  href: "https://christ-coaching.de",
  color: "#0E6D7D"
}, {
  label: "Tai Chi Schule Soonwald",
  href: "https://tai-chi-soonwald.de",
  color: "#2A5D37"
}, {
  label: "Wildnisschule Soonwald",
  href: "https://wildnisschule-soonwald.de",
  color: "#2F4F2F"
}];
const legalNav = [{
  label: "Impressum",
  href: "/impressum"
}, {
  label: "Widerrufsbelehrung",
  href: "/widerruf-2"
}, {
  label: "Datenschutz",
  href: "/datenschutz"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="235316" id="master-footer" className="bg-background text-foreground relative pt-16 pb-28 md:pb-16 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          
          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground tracking-tight border-b border-border pb-2">Seitennavigation</h3>
            <ul className="space-y-3">
              {siteNav.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.href} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors flex items-center gap-2 group">
                    <ChevronRight className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-all -ml-4 group-hover:ml-0" />
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground tracking-tight border-b border-border pb-2">Unsere Sektionen</h3>
            <ul className="space-y-3">
              {branches.map((branch, i) => <li key={branch.href} data-index={i}>
                  <Link to={branch.href} newTab className="text-sm font-sans font-medium hover:opacity-70 transition-opacity flex items-center gap-2" style={{
                color: branch.color
              }}>
                    <span className="h-1.5 w-1.5 rounded-lg" style={{
                  backgroundColor: branch.color
                }}></span>
                    {branch.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground tracking-tight border-b border-border pb-2">Kontakt</h3>
            <ul className="space-y-4 text-sm text-muted-foreground font-sans tracking-wide">
              <li className="flex items-center gap-3">
                <MapPin className="size-4 text-primary" />
                <span>Im Rödchen 3, 55595 Spabrücken</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="size-4 text-primary" />
                <span>Struthof 1, 55595 Münchwald</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 text-primary" />
                <span>+49 (0) 6706 9151738</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 text-primary" />
                <span className="break-all">post@claudiachrist.de</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg font-semibold mb-6 text-foreground tracking-tight border-b border-border pb-2">Rechtliches</h3>
            <ul className="space-y-3">
              {legalNav.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.href} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

        </div>

        <div className="border-t border-border mt-16 pt-8 flex justify-center text-center text-[12px] text-muted-foreground font-sans tracking-wider px-4">
          <p>© {currentYear} Resilienzzentrum Soonwald.<br className="sm:hidden" /> Alle Rechte vorbehalten.</p>
        </div>
      </div>

      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-background/80 backdrop-blur-xl border-t border-border z-50 px-8 py-4 flex justify-between items-center shadow-lg pb-safe">
        <Link to="/" className="flex flex-col items-center gap-1 text-muted-foreground hover:text-primary transition-all active:scale-95">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/3.svg" alt="Resilienzzentrum Soonwald" className="h-6 w-auto" />
          <span className="text-[10px] font-semibold uppercase tracking-widest font-sans">Start</span>
        </Link>
        <Link to="mailto:post@claudiachrist.de" className="flex flex-col items-center gap-1 text-muted-foreground hover:text-primary transition-all active:scale-95 relative">
          <img alt="Buchung" className="h-6 w-auto" src="https://resilienz-zentrum-soonwald.de/wp-content/uploads/2026/05/2-2.svg" />
          <span className="text-[10px] font-semibold uppercase tracking-widest font-sans">Anfrage</span>
          
        </Link>
        <Link to="https://resilienz-zentrum-soonwald.de/aktuelle-termine/" className="flex flex-col items-center gap-1 text-muted-foreground hover:text-primary transition-all active:scale-95">
          <img alt="Termine" className="h-6 w-auto" src="https://resilienz-zentrum-soonwald.de/wp-content/uploads/2026/05/1-1.svg" />
          <span className="text-[10px] font-semibold uppercase tracking-widest font-sans">Termine</span>
        </Link>
      </div>
    </footer>;
}